import { MRT_ColumnDef, MRT_TableInstance, useMaterialReactTable, MRT_Table } from 'material-react-table';
import { useEffect } from 'react';

interface FlattenedSkiAreaRow {
  parameter: string;
  [key: string]: any;
}

interface SkiAreaSensorTableProps {
  sensorRows: FlattenedSkiAreaRow[];
  columns: MRT_ColumnDef<FlattenedSkiAreaRow>[];
  onTableInstanceChange?: (instance: MRT_TableInstance<FlattenedSkiAreaRow>) => void;
}

export function SkiAreaSensorTable({ 
  sensorRows, 
  columns,
  onTableInstanceChange 
}: SkiAreaSensorTableProps) {
  const table = useMaterialReactTable({
    columns,
    data: sensorRows,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    muiTableBodyRowProps: { hover: false },
    muiTableContainerProps: {
      sx: { 
        width: '100%',
        userSelect: 'none',
        overflow: 'auto',
        '& .MuiTableCell-root': {
          background: '#ffffff'
        }
      }
    },
    muiTableProps: {
      sx: {
        tableLayout: 'fixed',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
      },
    },
    state: { density: 'compact' },
    enableTableHead: true,
    enableStickyHeader: true,
    enableHiding: false,
  });

  useEffect(() => {
    onTableInstanceChange?.(table);
  }, [table, onTableInstanceChange]);

  return <MRT_Table table={table} />;
}

export default SkiAreaSensorTable;
